import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from './api-base.token';
import { LoginApplication, LoginResponse } from './models';

const ADMIN_APPLICATION = 'admin';

type GenericSuccessResponse = {
  success: boolean;
};

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  login(email: string, password: string) {
    return this.http.post<LoginResponse>(`${this.apiBaseUrl}/api/login`, {
      email,
      password,
    });
  }

  requestPasswordReset(email: string, application: LoginApplication = ADMIN_APPLICATION) {
    return this.http.post<GenericSuccessResponse>(`${this.apiBaseUrl}/api/auth/forgot-password`, {
      email,
      application,
    });
  }

  resetPassword(token: string, password: string) {
    return this.http.post<GenericSuccessResponse>(`${this.apiBaseUrl}/api/auth/reset-password`, {
      token,
      password,
      application: ADMIN_APPLICATION,
    });
  }
}
